import { ButtonSecondary, LinkPrimary, Typography } from '@klarna/bubble-ui'
import React, { useState } from 'react'
import { getItem, setItem } from 'common/utils/local-storage'

import styles from './index.css'
import useHppContext from 'common/hooks/use-hpp-context'
import useTranslate from 'common/hooks/use-translate'

function CookieLegalNotice() {
  const { featureFlags } = useHppContext()
  const translate = useTranslate()

  const showCookieNotice = featureFlags && featureFlags.includes('cookieLegalNotice')
  const agreedWithCookies = getItem('agreedWithCookies')
  const [visible, setVisible] = useState(showCookieNotice && !agreedWithCookies)

  function agreeWithCookies() {
    setItem('agreedWithCookies', '1')
    setVisible(false)
  }

  if (!visible) {
    return null
  }

  return (
    <div className={styles.wrapper} id="cookiesConcern">
      <div className={styles.content}>
        <span className={styles.text}>
          <Typography textToken="text-style/text/super-paragraphs/body/regular">
            {translate('cookie_legal_notice.text')}
          </Typography>
        </span>
        <div className={styles.actions}>
          <ButtonSecondary onClick={agreeWithCookies} id="okBtn">
            {translate('cookie_legal_notice.accept')}
          </ButtonSecondary>
          <LinkPrimary
            white
            href={translate('cookie_legal_notice.learn_more.link')}
            target="_blank"
            className={styles.learnMore}
            id="learnMoreBtn"
          >
            {translate('cookie_legal_notice.learn_more.text')}
          </LinkPrimary>
        </div>
      </div>
    </div>
  )
}

export default CookieLegalNotice
